import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  IApiResponse,
  IEquipamento,
  IGetEquipamentosQueryParams,
  IListaPaginada,
  IEquipamentoLocalizacao,
  IPostEquipamentoLocalizacaoResponseData,
  IGerarTokenQRCodeRequest,
  IGerarTokenQRCodeResponse,
  IValidarTokenEquipamentoRequest,
  IValidarTokenEquipamentoResponse
} from 'src/app/interfaces';
import { IProducao } from 'src/app/interfaces/equipamento/IProducao';
import { IChamados } from 'src/app/pages/servicos/listar-equipamentos-detalhes/listar-equipamentos-detalhes.component';

@Injectable({
  providedIn: 'root'
})
export class EquipamentoService {
  private readonly baseURL = '/Equipamento';

  constructor(private httpClient: HttpClient) {}

  getEquipamentos(body: IGetEquipamentosQueryParams) {
    console.log(body);

    return this.httpClient.post<IApiResponse<IListaPaginada<IEquipamento>>>(
      this.baseURL,
      body
    );
  }

  getHistoricoChamados(numSerie?: string) {
    return this.httpClient.post<IApiResponse<IChamados[]>>(
      `${this.baseURL}/HistoricoOS/${numSerie}`,
      {}
    );
  }

  getDownloadPDFFechamento(body: IGetEquipamentosQueryParams) {
    return this.httpClient.post<IApiResponse<string>>(
      this.baseURL + '/exportarPDFEquipamento',
      body
    );
  }

  getDownloadCSVFechamento(body: IGetEquipamentosQueryParams) {
    return this.httpClient.post<IApiResponse<string>>(
      this.baseURL + '/exportarCSVEquipamento',
      body
    );
  }

  getProducaoEquipamento(numSerie?: string) {
    return this.httpClient.post<IApiResponse<IProducao[]>>(
      `${this.baseURL}/producao/${numSerie}`,
      {}
    );
  }

  postAlterarLocalizacao(body: IEquipamentoLocalizacao) {
    return this.httpClient.post<
      IApiResponse<IPostEquipamentoLocalizacaoResponseData>
    >(this.baseURL + '/alterarLocalizacao', body);
  }

  // Gerar token para QR Code
  gerarTokenEquipamento(
    netName: string
  ): Observable<IApiResponse<IGerarTokenQRCodeResponse>> {
    const body: IGerarTokenQRCodeRequest = {
      netName: netName
    };

    return this.httpClient.post<IApiResponse<IGerarTokenQRCodeResponse>>(
      `${this.baseURL}/gerarTokenEquipamento`,
      body
    );
  }

  validarTokenEquipamento(
    token: string
  ): Observable<IApiResponse<IValidarTokenEquipamentoResponse>> {
    const body: IValidarTokenEquipamentoRequest = {
      token: token
    };

    return this.httpClient.post<IApiResponse<IValidarTokenEquipamentoResponse>>(
      `${this.baseURL}/validarTokenEquipamento`,
      body
    );
  }
}
